import { mapActions } from 'vuex'
import { sorts } from './partials/fields'

export default {
    template: '<router-view />',

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.setParams({
                sorter: sorts[0].value,
                store: {
                    id: vm.storeId
                }
            })
            vm.fetch()
            if (vm.$policy('campaign').create_any_or_group) {
                vm.fetchStoreTags()
            }
        })
    },

    beforeRouteLeave (to, from, next) {
        this.resetParams()
        next()
    },

    methods: {
        ...mapActions({
            fetch: 'campaign/fetch',
            setParams: 'campaign/setParams',
            resetParams: 'campaign/resetParams',
            fetchStoreTags: 'store/fetchTags'
        }),
    }
}